/**
 * Renders a sliding drawer
 */

import React from 'react';
import { observer } from 'mobx-react';

// Components
import * as icons from '../ui/Icons';

const Drawer = observer(class Drawer extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.closeDrawer = this.closeDrawer.bind(this);
  }

  closeDrawer() {
    const { AppStore } = this.props.store;

    AppStore.closeDrawer();
  }

  render() {
    const { AppStore } = this.props.store;
    const { drawerLeave, drawerProps, drawerTitle } = AppStore;
    const DrawerContent = AppStore.drawerContent;

    return (
      <div className="drawer-wrap">
        <article
          className={`drawer${drawerLeave ? ' drawer--exiting' : ''}`}
        >
          <div className="drawer__content">
            <header className="drawer__head">
              {drawerTitle &&
                <h1 className="drawer__title">
                  {drawerTitle}
                </h1>
              }

              <button
                className="drawer__close"
                onClick={this.closeDrawer}
              >
                <icons.times />
                
                <span className="meta">Close</span>
              </button>
            </header>

            <DrawerContent
              {...this.props}
              {...drawerProps}
            />
          </div>
        </article>
      </div>
    )
  }
})

export default Drawer;
